import { Box, useTheme } from "@mui/material";

export interface IActivityFieldLabelProps {
    label: string;
    disabled?: boolean;
    hasError?: boolean;
}

// Matches the fixed label DotLegal fields draw above themselves, including the top margin of the field. The
// library does not export it, and a date that switches to a relative date, or a switch, still needs the label.
function ActivityFieldLabel(props: IActivityFieldLabelProps) {
    const theme = useTheme();

    function getColor() {
        if (props.disabled) {
            return theme.palette.text.disabled;
        }

        return props.hasError ? theme.palette.error.main : theme.palette.primary.dark;
    }

    return (
        <Box sx={{ fontSize: theme.typography.pxToRem(14), lineHeight: 1.4, fontWeight: 600, color: getColor(), marginTop: 2, marginBottom: "4px" }}>
            {props.label}
        </Box>
    );
}

export default ActivityFieldLabel;
